package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.util.Constants.AMBER_500
import org.multiplatform.kotfolio.util.Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun Logo(
    modifier: Modifier = Modifier,
    isDark: Boolean = false,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        /*Row(verticalAlignment = Alignment.CenterVertically) {
            // Blinking cursor
            Box(
                modifier = Modifier
                    .width(12.px)
                    .height(20.px)
                    .backgroundColor(AMBER_500)
                    .margin(left = 4.px, right = 10.px)
                    .animation(
                       CodeWindowBlinkKeyframes.toAnimation(
                            duration = 1.s,
                            iterationCount = AnimationIterationCount.Infinite,
                            timingFunction = AnimationTimingFunction.EaseInOut,
                        ),
                    ),
            )
        }*/

        // Text: Far (Amber) + suller. (White/Dark)
        Row {
            Span(
                attrs = Modifier
                    .color(AMBER_500)
                    .fontSize(22.px)
                    .fontWeight(FontWeight.Black)
                    .fontFamily(FONT_FAMILY)
                    .toAttrs(),
            ) {
                Text("Multi")
            }
            Span(
                attrs = Modifier
                    .color(if (isDark) Color.rgb(44, 62, 80) else Colors.White)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Black)
                    .fontFamily(FONT_FAMILY)
                    .toAttrs(),
            ) {
                Text("platform Developer")
            }
        }
    }
}
